<script>
import router from "../../router";
export default {
  name: "ViewPurchaseOrder",
  components: {},
  data() {
    return {
      items: [],
      additinal_fee: [],
      get_items: {
        id: "",
        name: "",
        sku: "",
        quantity: "",
        quantity_received: "",
        get_quantity: ""
      },
      id: null,
      get_additinal_fee: {
        id: "",
        title: "",
        cost: "",
        po_id: false
      }
    };
  },
  methods: {
    details(id) {
      this.$api
        .getAPI({
          _action: "/order/detail/" + id
        })
        .then(res => {
          this.id = res.purchase_order.id;
          for (var i = 0; i < res.items.length; i++) {
            if (res.items[i].po_status != "COMPLETED") {
              this.get_items = {};
              this.get_items.id = res.items[i].id;
              this.get_items.get_quantity = res.items[i].quantity;
              this.get_items.quantity_received = res.items[i].quantity_received;
              this.get_items.name = res.items[i].item.name;
              this.get_items.sku = res.items[i].item.sku;
              this.get_items.quantity = 0.0;
              this.items.push(this.get_items);
            }
          }
          for (var i = 0; i < res.additional_fees.length; i++) {
            if (res.additional_fees[i].po_additional_status == "PENDING") {
              this.get_additinal_fee = {};
              this.get_additinal_fee.id = res.additional_fees[i].id;
              this.get_additinal_fee.title = res.additional_fees[i].title;
              this.get_additinal_fee.cost = res.additional_fees[i].cost;
              this.get_additinal_fee.po_id = false;
              this.additinal_fee.push(this.get_additinal_fee);
            }
          }
        });
    },
    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.save();
          return;
        }
      });
    },

    markAllRead() {
      for (var i = 0; i < this.items.length; i++) {
        var quantity_received = 0.0;
        if (this.items[i].quantity_received) {
          quantity_received = this.items[i].quantity_received;
        }
        this.items[i].quantity = this.items[i].get_quantity - quantity_received;
        this.$set(this.items, i, this.items[i]);
      }

      for (var i = 0; i < this.additinal_fee.length; i++) {
        this.additinal_fee[i].po_id = true;
        this.$set(this.additinal_fee, i, this.additinal_fee[i]);
      }
    },

    save() {
      var list1 = [];
      for (var i = 0; i < this.additinal_fee.length; i++) {
        if (this.additinal_fee[i].po_id) {
          list1.push(this.additinal_fee[i]);
        }
      }
      var obj = {};
      obj.id = this.id;
      obj.items = this.items;
      obj.additional_fees = list1;

      this.$api
        .postAPI({
          _action: "/order/received",
          _body: obj,
          _buttonId: "save-btn"
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });

          router.push("/view-purchase-order/" + this.$route.params.id);
        })
        .catch(e => {});
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.details(this.$route.params.id);
    }
  }
};
</script>
<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-9">
            <div class="card rounded-5 border">
              <div class="card-header bg-white border-bottom px-lg-5 px-4 py-4">
                <div class="row">
                  <div class="col-lg-3 col-md-5 align-self-center mb-md-0 mb-3">
                    <a href="javascript:void(0)" @click="$router.go(-1)" class="text-primary">
                      <i class="mdi mdi-chevron-left"></i>
                      {{$lang.messages.purchase_order}}
                    </a>
                  </div>
                  <div class="col-lg-9 col-md-7 text-right">
                    <button
                      type="button"
                      class="btn btn-primary mr-lg-2 mb-md-0 mb-3 w-xs-100"
                      @click="markAllRead()"
                    >{{$lang.messages.mark_all_received}}</button>
                  </div>
                </div>
              </div>
              <div class="card-body form-style px-lg-5 px-4 py-4">
                <div class="row" v-if="items.length > 0">
                  <div class="col-lg-12">
                    <h1>{{$lang.messages.items}}</h1>
                    <table class="table table-striped table-style-1 table-responsive">
                      <thead>
                        <tr>
                          <th scope="col">{{$lang.messages.item}}</th>
                          <th scope="col">{{$lang.messages.ordered}}</th>
                          <th scope="col">{{$lang.messages.received}}</th>
                          <th scope="col" class="text-right">{{$lang.messages.to_receive}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(obj, index)  in items" :key="obj.id">
                          <td>
                            {{obj.name}}
                            <br />
                            <span class="font-14 text-grey" v-if="obj.sku">SKU {{obj.sku}}</span>
                          </td>
                          <td>{{obj.get_quantity}}</td>
                          <td>{{obj.quantity_received ? obj.quantity_received : '0'}}</td>
                          <td class="text-right">
                            <input
                              placeholder="0.00"
                              type="text"
                              v-model="obj.quantity"
                              v-validate="'decimal|min_value:0'"
                              :id="'composite_item_quantity_' + index"
                              :name="'composite_item_quantity_' + index"
                              :class="{'form-control':true, 'input': true, 'is-danger': errors.has('composite_item_quantity_' + index) }"
                            />
                            <i
                              v-show="errors.has('composite_item_quantity_'+ index)"
                              class="fa fa-warning"
                            ></i>
                            <span
                              v-show="errors.has('composite_item_quantity_'+ index)"
                              class="help is-danger"
                            >{{$lang.messages.please_enter_quantity}}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="row" v-if="additinal_fee.length > 0">
                  <div class="col-lg-12">
                    <h4>{{$lang.messages.select_additional_costs_to_apply_to_this_receipt}}</h4>
                    <table class="table table-striped table-style-1 table-responsive">
                      <thead>
                        <tr>
                          <th></th>
                          <th scope="col">{{$lang.messages.title}}</th>
                          <th scope="col">{{$lang.messages.cost}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="obj  in additinal_fee" :key="obj.id">
                          <td>
                            <input type="checkbox" v-model="obj.po_id" id="switch-1" class="switch" />
                          </td>
                          <td v-if="!!$lang.messages[obj.title]">{{$lang.messages[obj.title]}}</td>
                          <td v-else>{{obj.title}}</td>
                          <td>{{obj.cost}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-9 text-right">
            <button
              type="button"
              id="save-btn"
              class="btn btn-primary mr-3"
              @click="validateForm()"
            >{{$lang.messages.receive}}</button>
            <button
              type="button"
              @click="$router.go(-1)"
              class="btn btn-outline-primary"
            >{{$lang.messages.cancel_btn_text}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>